import instance from './instance'

const clientWalletUrl = 'modules-lead/client-wallets'

export const getClientWalletList = (page: number, pageSize: number, filterKey: any) =>
  instance.get(`${clientWalletUrl}?page=${page}&pageSize=${pageSize}&filterkey=${filterKey}`)
